import { Component, inject } from '@angular/core';

import { CommonModule } from '@angular/common';
import { IntrospectKeysService } from '@core/services/introspect-keys.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'rh-introspect-key',
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatGridListModule,
    ],
    templateUrl: './introspect-key.component.html',
    styleUrl: './introspect-key.component.scss'
})
export class IntrospectKeyComponent {
  readonly introspectKeysService = inject(IntrospectKeysService);

  get introspectResponse$() {
    return this.introspectKeysService.introspectResponse();
  }

  get introspectError$() {
    return this.introspectKeysService.introspectError();
  }
}
